import { atom } from 'recoil';

export const refreshDataState = atom({
  key: 'refreshDataState',
  default: false,
});

export const roomIdStateRecoil = atom<number | null>({
  key: 'roomIdStateRecoil',
  default: null,
});

export const lineIdStateRecoil = atom<number | null>({
  key: 'lineIdStateRecoil',
  default: null,
});

// 현위치 모달 뷰 권한 관리
export const locationShareStateRecoil = atom<boolean>({
  key: 'locationShareStateRecoil',
  default: false,
});

// 방에 있는 인원 userId 배열
export const roomPeoplesUserIdsStateRecoil = atom<number[]>({
  key: 'roomPeoplesUserIdsStateRecoil',
  default: [],
});
